export default "__VITE_PUBLIC_ASSET__8ce43164__"